<template>
  <div class="main">
    <div class="desc">{{ brandName }}</div>
    <a-form
      :form="form"
      class="user-layout-login"
      ref="formLogin"
      id="formLogin"
    >
      <a-form-item>
        <j-search-select-tag
          placeholder="请选择校区"
          v-decorator="[
            'departId',
            {rules: validatorRules.departId.rules },
          ]"
          dict="sys_depart,depart_name,id,org_category=1">
        </j-search-select-tag>
      </a-form-item>

      <a-form-item>
        <a-input
          size="large"
          v-decorator="[
            'username',
            { initialValue: 'student', rules: validatorRules.username.rules },
          ]"
          type="text"
          placeholder="请输入帐户名"
        >
          <a-icon
            slot="prefix"
            type="user"
            :style="{ color: 'rgba(0,0,0,.25)' }"
          />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input
          v-decorator="[
            'password',
            {
              initialValue: '123456',
              rules: validatorRules.password.rules,
            },
          ]"
          size="large"
          type="password"
          autocomplete="false"
          placeholder="密码"
        >
          <a-icon
            slot="prefix"
            type="lock"
            :style="{ color: 'rgba(0,0,0,.25)' }"
          />
        </a-input>
      </a-form-item>
      <!-- <a v-if="loginRole=='teacher'" href="/user/login?role=student">学生登录</a> -->
      <!-- <a v-else href="/user/login?role=teacher">教师登录</a> -->
      <a-form-item style="margin-top: 40px">
        <a-button
          size="large"
          htmlType="submit"
          class="login-button"
          :loading="loginBtn"
          @click.stop.prevent="handleSubmit"
          :readOnly="loginBtn"
          >登录
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
//import md5 from "md5"
import api from "@/api";
import { mapActions } from "vuex";
import { timeFix } from "@/utils/util";
import Vue from "vue";
import { ACCESS_TOKEN, ENCRYPTED_STRING } from "@/store/mutation-types";
import { putAction, postAction, getAction } from "@/api/manage";
import { encryption, getEncryptedString } from "@/utils/encryption/aesEncrypt";
import store from "@/store/";
import { USER_INFO } from "@/store/mutation-types";
import JSearchSelectTag from "@/components/jeecg/JSearchSelectTag";

export default {
  name: "Login",
  components: {
    JSearchSelectTag
  },
  data() {
    return {
      brandName: this.$store.getters.tenantInfo.brandName,
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      form: this.$form.createForm(this),
      encryptedString: {
        key: "",
        iv: "",
      },
      validatorRules: {
        username: {
          rules: [
            { required: true, message: "请输入用户名!" },
            { validator: this.handleUsernameOrEmail },
          ],
        },
        password: {
          rules: [
            { required: true, message: "请输入密码!", validator: "click" },
          ],
        },
        departId:{
          // rules: [
          //   { required: true, message: "请选择校区!", validator: "click" },
          // ],
        }
      },
      currentUsername: "",
      currdatetime: "",
      randCodeImage: "",
      requestCodeSuccess: false,
      loginParams: {}
    };
  },
  created() {
    this.currdatetime = new Date().getTime();
    this.getRouterData();
  },
  methods: {
    ...mapActions(["Login", "mLogin", "Logout"]),
    handleUsernameOrEmail(rule, value, callback) {
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
      if (regex.test(value)) {
        this.loginType = 0;
      } else {
        this.loginType = 1;
      }
      callback();
    },
    handleSubmit() {
      let that = this;
      that.loginBtn = true;
      // 使用账户密码登录
      that.form.validateFields(
        ["username", "password", "inputCode","departId", "rememberMe"],
        { force: true },
        (err, values) => {
          if (!err) {
            that.loginParams.username = values.username;
            that.loginParams.password = values.password;
            console.log("登录参数", that.loginParams);
            that
              .mLogin(that.loginParams)
              .then((res) => {
                if (res.result.role.length == 0) {
                  that.cmsFailed("账号角色未知");
                }
                this.loginSuccess(res);
              })
              .catch((err) => {
                that.requestFailed(err);
              });
          } else {
            that.loginBtn = false;
          }
        }
      );
    },
    loginSuccess(res) {
      this.$emit("success");
      this.$notification.success({
        message: "欢迎",
        description: `${timeFix()}，欢迎回来`,
      });
      //判断登录角色，进入不同页面
      if (res.result.role.includes("teacher")) {
        this.$router.push("/teacher");
      } else if (res.result.role.includes("admin")) {
        this.$router.push("/teacher");
      } else {
        this.$router.push("/student");
      }
    },
    cmsFailed(err) {
      this.$notification["error"]({
        message: "登录失败",
        description: err,
        duration: 4,
      });
    },
    requestFailed(err) {
      this.$notification["error"]({
        message: "登录失败",
        description:
          ((err.response || {}).data || {}).message ||
          err.message ||
          "请求出现错误，请稍后再试",
        duration: 4,
      });
      this.loginBtn = false;
    },
    getRouterData() {
      this.$nextTick(() => {
        if (this.$route.params.username) {
          this.form.setFieldsValue({
            username: this.$route.params.username,
          });
        }
      });
    },
    //获取密码加密规则
    getEncrypte() {
      var encryptedString = Vue.ls.get(ENCRYPTED_STRING);
      if (encryptedString == null) {
        getEncryptedString().then((data) => {
          this.encryptedString = data;
        });
      } else {
        this.encryptedString = encryptedString;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  .desc {
    font-size: 25px;
    color: rgba(0, 0, 0, 0.45);
    text-align: center;
    margin-bottom: 40px;
  }
}
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    width: 266px;
    height: 59px;
    background: var(--primary-color);
    border-radius: 30px;
    font-size: 22px;
    color: #fff;
    line-height: 30px;
    font-family: inherit;
    padding: 0 15px;
  }
}
</style>
<style>
.valid-error .ant-select-selection__placeholder {
  color: #f5222d;
}
</style>